import { useMutation, useQueryClient } from 'react-query';
import request from '../helpers/request';

export const resetDefaultFilter = async (id) => {
  const data = { id, value: false };

  return await request.put(
    '/Filter/default',
    data,
    'Произошла ошибка при сбросе фильтра',
    'Error',
    null,
    { type: 'ALERT' }
  );
};

const useResetDefaultFilterShutdowns = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(resetDefaultFilter, {
    onSuccess: (data) => {
      if (data === 'Error') return;

      queryClient.invalidateQueries(['shutdowns', 'savedFilters']);
    },
  });

  return {
    isResetFilterLoading: mutation.isLoading,
    resetFilter: mutation.mutateAsync,
  };
};

export default useResetDefaultFilterShutdowns;
